/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
    Grid, Button, IconButton, TextField,
    InputAdornment, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, TablePagination, Tooltip, MenuItem, InputLabel, FormControl, Select
} from '@mui/material';
import katex from "katex";
import "katex/dist/katex.min.css";
import moment from 'moment'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {Search} from 'lucide-react';
import Page from '../../../components/Page'
import PageHeader from '../../../components/PageHeader';
import DeleteAlert from '../../../components/modal/DeleteModal';
import SnackBar from '../../../components/snackbar/snackbar';
import CreateSATQuestionModel from './CreateSatQuestions';
import EditQuestionModule from "./EditSATQuestions";
import adminServices from '../../../services/adminServices';
import './styles.css';

const SatAssessment = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = useState(false);
    const [snackbarTitle, setSnackbarTitle] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [openCreateSat, setOpenCreateSat] = useState(false);
    const [openEditMcq, setOpenEditMcq] = useState(false);
    const [newData, setNewData] = React.useState('');
    const [searchedDetails, setSearchedDetails] = useState('');
    const [satDetails, setSatDetails] = useState([]);
    const [total, setTotal] = useState('');
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [deleteModalTitle, setDeleteModalTitle] = useState('');
    const [deleteId, setDeleteId] = useState('')
    const [deleteType, setDeleteType] = useState('')
    const [questionType, setQuestionType] = useState('English');

    const handleTypeChange = (event) => {
        setQuestionType(event.target.value);
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        getSATDetails()
    }, [page, rowsPerPage, searchedDetails, questionType])


    const getSATDetails = async () => {
        const result = await adminServices.getSATDetails(page, rowsPerPage, searchedDetails, questionType);
        if (result.ok) {
            const reverseOrderQuestionList = result.data.questions?.reverse()
            setSatDetails(reverseOrderQuestionList)
            setTotal(parseInt(result.data.total, 10))
        }

    }

    const renderKatexHTML = (html) => {
        if (!html) return "";
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const formulas = doc.querySelectorAll(".ql-formula");
        formulas.forEach((el) => {
            const tex = el.getAttribute("data-value");
            if (tex) {
                try {
                    el.innerHTML = katex.renderToString(tex, {
                        throwOnError: false,
                        displayMode: false,
                    });
                } catch (err) {
                    console.warn("KaTeX render error:", err);
                }
            }
        });

        return doc.body.innerHTML;
    };
    const handleEdit = (values) => {
        setNewData(values)
        setOpenEditMcq(true)
    }
    const handleCreateSAT = () => {
        setOpenCreateSat(true)
    }

    const handleEditCallBack = () => {
        setOpenEditMcq(false)
    }
    const CallBackRemove = () => {
        setOpenCreateSat(false)
        getSATDetails()
    }
    const CallBackEditRemove = () => {
        setOpenEditMcq(false)
        getSATDetails()
    }


    const handleDelete = (data) => {
        setDeleteAlert(true);
        setDeleteId(data.id);
        setDeleteType(data?.question_type);
        setDeleteModalTitle('Are you sure you want delete this Sat Question?');
    }

    const handleDeleteSat = async () => {
        try {
            const response = await adminServices.deleteSATDetails(deleteId, deleteType);
            if (response.ok) {
                if (response.data.message) {
                    setSnackbarTitle(response.data.message);
                }
                else {
                    setSnackbarTitle('Sat Question deleted successfully');
                }
                setOpenSnackbar(true);
                getSATDetails();
                setDeleteAlert(false)
                setDeleteId('')
                setDeleteType('')
                setDeleteModalTitle("");
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleSearch = (searchedDetails) => {
        setPage(0);
        setSearchedDetails(searchedDetails);

    }

    const sortedData = satDetails?.sort((a, b) =>
        new Date(b.created_date) - new Date(a.created_date)
    ) || [];

    return (
        <Page title="SAT Assessment Questions">
            <PageHeader pageTitle="SAT Assessment Questions" submodule="submodule" />
            <>
                <Grid container spacing={2}>

                    <Grid align="end" item xs={12}>
                        <FormControl size="small" sx={{ width: '150px', marginRight: '10px', height: '46px' }}>
                            <InputLabel id="question-type-label" style={{ maxHeight: '46px' }}>Type</InputLabel>
                            <Select
                                sx={{
                                    textAlign: 'left',
                                    '& .MuiSelect-select': {
                                        padding: '8px 12px'
                                    }
                                }}
                                labelId="question-type-label"
                                id="question-type-select"
                                value={questionType}
                                label="Type"
                                onChange={handleTypeChange}
                            >

                                <MenuItem value="English">English</MenuItem>
                                <MenuItem value="Maths">Maths</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            variant="outlined"
                            placeholder="Search Name"
                            id="searchassessment"
                            size="small"
                            sx={{ width: '250px', height: '40px' }}
                            value={searchedDetails}
                            onChange={(e) => handleSearch(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search id={`editsat`} />
                                    </InputAdornment>
                                ),
                                sx: { height: '100%' },
                            }}
                        />


                        <Button
                            style={{ marginLeft: '15px', height: '40px' }}
                            id="createassessmentButtongeneral"
                            variant="contained"
                            color="primary"
                            onClick={handleCreateSAT}
                        >
                            Create SAT
                        </Button>
                    </Grid>
                    <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                        <Table id="SATQuestionTable" sx={{ marginLeft: '15px', width: '98%' }}>
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', paddingLeft: '8px !important' }}>Name</TableCell> */}
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Type</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>author</TableCell>

                                    {/* <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Live</TableCell> */}
                                    {/* <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Questions</TableCell> */}
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Level</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Question</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Date</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {sortedData && sortedData?.length > 0 && (
                                    sortedData?.map((row) => {
                                        return (
                                            <TableRow key={row.id} sx={{ '&:hover': { backgroundColor: '#f1f1f1' } }}>
                                                <TableCell dangerouslySetInnerHTML={{ __html: row?.question_type }} sx={{ marginLeft: '40px' }} />

                                                <TableCell sx={{ marginLeft: '40px' }}>{row?.firstname} {row?.lastname}</TableCell>

                                                <TableCell sx={{ marginLeft: '40px' }}>
                                                    {row?.level.charAt(0).toUpperCase() + row?.level.slice(1).toLowerCase()}
                                                </TableCell>

                                                {/* <TableCell dangerouslySetInnerHTML={{ __html: row?.question_text }} /> */}
                                                <TableCell
                                                    dangerouslySetInnerHTML={{ __html: renderKatexHTML(row?.question_text) }}
                                                />

                                                <Tooltip title={`ID: ${row.id}`} arrow>
                                                    <TableCell>
                                                        {moment(row.created_date).format("DD/MM/YYYY")}
                                                    </TableCell>
                                                </Tooltip>

                                                <Tooltip title={`ID: ${row.id}`} arrow>
                                                    <TableCell sx={{ padding: '10px' }}>
                                                        <IconButton
                                                            id={`editsat${row.id}`}
                                                            onClick={() => handleEdit(row.id)}
                                                            color="primary">
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            id={`deletesat${row.id}`}
                                                            onClick={() => handleDelete(row)}
                                                            color="primary">
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </Tooltip>
                                            </TableRow>
                                        )
                                    })
                                )

                                }
                            </TableBody>




                        </Table>
                    </TableContainer>

                    <TablePagination
                        component="div"
                        count={total}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10, 15, 20, 25]}
                        sx={{ marginTop: 2 }}
                    />

                    <TextField label="Search Page Number" variant="outlined" size="small"
                        value={page + 1}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (val === "" || /^\d+$/.test(val)) {
                                const pageNum = val === "" ? 1 : parseInt(val, 10);
                                const maxPage = Math.ceil((total || 0) / rowsPerPage);
                                const newPageIndex = Math.max(0, Math.min(pageNum - 1, maxPage - 1));
                                setPage(newPageIndex);
                            }
                        }}
                        sx={{
                            width: '200px',
                            maxHeight: '39px',
                            height: '40px',
                            marginRight: '8px',
                            marginLeft: "15px",
                            marginTop: 3,
                            '& .MuiInputBase-input::placeholder': {
                                position: 'absolute',
                                top: '-10px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: '#fff',
                                padding: '0 4px',
                                maxHeight: '39px',
                                height: '40px',
                                fontSize: '0.75rem',
                                color: '#888',
                            },
                            '& .MuiInputBase-input': {
                                padding: '8.5px 14px',
                            },

                        }}

                    />
                    <DeleteAlert
                        open={deleteAlert}
                        title={deleteModalTitle}
                        confirm={handleDeleteSat}
                        close={() => setDeleteAlert(false)}
                    />
                    <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
                    <CreateSATQuestionModel
                        open={openCreateSat}
                        modelClose={() => setOpenCreateSat(!openCreateSat)}
                        title="Create Sat"
                        // handleCreateMcq={handleSubmitForm}
                        loading={loading}
                        // searchedDetails={searchedDetails}
                        CallBack={CallBackRemove}
                    />
                    <EditQuestionModule
                        open={openEditMcq}
                        modelClose={() => setOpenEditMcq(!openEditMcq)}
                        title="Edit SAT"
                        handleEditMcq={handleEditCallBack}
                        loading={loading}
                        searchedDetails={searchedDetails}
                        data={newData}
                        CallBack={CallBackEditRemove}
                    />
                </Grid>
            </>
        </Page>
    )
}

export default SatAssessment;